import { FC } from 'react';

import { CustomCallback } from '@shared/types';
import { motion } from 'framer-motion';
import { useId } from 'react-id-generator';

interface IProps {
  toggle: boolean;
  onChagne: CustomCallback<boolean, void>;
  toggleValue: {
    on: string;
    off: string;
  };
  activeOnClassName?: string;
  activeOffClassName?: string;
}

/**
 * @param toggle 기존 값을 넣기 위한 용도
 * @param toggleValue on, off 시 보이는 값(string)
 * 왼쪽이 on 오른쪽이 off
 * @returns
 */

const Toggle: FC<IProps> = ({
  toggle,
  toggleValue,
  onChagne,
  activeOnClassName,
  activeOffClassName,
}: IProps) => {
  const [id] = useId(1, 'toggle');

  const onToggleOnClick = () => onChagne(true);

  const onToggleOffClick = () => onChagne(false);

  const onBgClass = activeOnClassName ?? 'theme-bg-13';
  const offBgClass = activeOffClassName ?? 'theme-bg-13';

  return (
    <div className="input-box my-auto grid grid-cols-2 border p-[1px] text-[14px] theme-bg-1 theme-border-1">
      <div className="relative">
        {toggle && (
          <motion.div
            layoutId={`toggle-background-${id}`}
            className={`absolute h-full w-full ${onBgClass}`}
          ></motion.div>
        )}
        <div
          className={`relative z-10 cursor-pointer bg-transparent py-2.5 px-3.5 text-center font-bold ${
            toggle ? (activeOnClassName ? 'text-white' : 'theme-text-4') : 'text-gray-500'
          }`}
          onClick={onToggleOnClick}
        >
          {toggleValue.on}
        </div>
      </div>
      <div className="relative">
        {!toggle && (
          <motion.div
            layoutId={`toggle-background-${id}`}
            className={`absolute h-full w-full ${offBgClass}`}
          ></motion.div>
        )}
        <div
          className={`relative z-10 cursor-pointer bg-transparent py-2.5 px-3.5 text-center font-bold ${
            !toggle
              ? activeOffClassName
                ? 'text-white'
                : 'theme-text-4'
              : 'text-gray-500'
          }`}
          onClick={onToggleOffClick}
        >
          {toggleValue.off}
        </div>
      </div>
    </div>
  );
};

export default Toggle;
